import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingCart } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import ProductCard from "../components/ProductCard";
import { useFavorites } from "../lib/favorites-context";
import { useCart } from "../lib/cart-context";

export default function FavoritesPage() {
  const { products } = useFavorites();
  const { addItem, refresh } = useCart();

  const addAll = async () => {
    if (!products.length) return;
    for (const p of products) {
      try {
        await addItem(p, 1);
      } catch {
        /* continue */
      }
    }
    await refresh();
    toast.success(`${products.length} productos añadidos al carro`);
  };

  return (
    <div
      data-testid="favorites-page"
      className="mx-auto max-w-7xl px-4 sm:px-6 py-6 sm:py-10"
    >
      <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
        <div>
          <h1 className="text-3xl sm:text-4xl font-black tracking-tight">
            Mis habituales
          </h1>
          <p className="text-neutral-500 mt-1">
            Los productos que compras a menudo, siempre a mano.
          </p>
        </div>
        {products.length > 0 && (
          <Button
            onClick={addAll}
            data-testid="favorites-add-all-btn"
            className="rounded-full bg-[#00953B] hover:bg-[#007a30] text-white gap-2"
          >
            <ShoppingCart className="h-4 w-4" /> Añadir todos al carro
          </Button>
        )}
      </div>

      {products.length === 0 ? (
        <div
          data-testid="favorites-empty"
          className="rounded-2xl border border-dashed border-neutral-300 p-12 text-center"
        >
          <div className="h-14 w-14 mx-auto rounded-full bg-neutral-100 grid place-items-center mb-3">
            <Heart className="h-6 w-6 text-neutral-400" />
          </div>
          <p className="font-semibold text-lg">Aún no tienes habituales</p>
          <p className="text-sm text-neutral-500 mt-1">
            Toca el corazón en un producto para añadirlo a tus habituales.
          </p>
          <Button
            asChild
            className="mt-6 rounded-full bg-[#00953B] hover:bg-[#007a30] text-white"
          >
            <Link to="/">Explorar productos</Link>
          </Button>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
